import AppLoader from "frontend/loader/app-loader";
import { useEffect, useState } from "react";
import { getPathPrefix } from "../utils/getPathPrefix";

export function CreatingTemplateIntegrationModal() {
  const [currentSentence, setCurrentSentence] = useState(0);
  const sentences = [
    "Setting up your monday board...",
    "Syncing your monday board with workcanvas...",
    "Fetching the items...",
    "Placing everything in the right place...",
    "Finishing up...",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSentence((currentSentence) => (currentSentence + 1) % sentences.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        zIndex: 10,
        padding: 30,
        width: "80%",
        height: "70vh",
        background: "white",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        filter: "drop-shadow(0px 0px 10px rgba(0,0,0,0.2))",
      }}
    >
      <AppLoader lottieSrc={getPathPrefix("/images/integrations-loader.json")} />
      <div
        style={{
          position: "absolute",
          top: "70%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
        }}
      >
        {sentences[currentSentence]}
      </div>
    </div>
  );
}
